import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';
import { SiteMaintenanceBanner } from './SiteMaintenanceBanner';

/**
 * Shared page shell used by all routes.
 */
export function SiteLayout() {
  return (
    <div className="app-shell">
      <SiteHeader />
      <SiteMaintenanceBanner />
      <main>
        <Suspense fallback={<div className="page notice" role="status">Loading page...</div>}>
          <Outlet />
        </Suspense>
      </main>
      <SiteFooter />
    </div>
  );
}
